import { useGetArtistAnalyticsApiV1Suspense } from "@/api/__generated__/api.schema";
import { useWorkspaceId } from "@/hooks/auth/use-workspace";
import { RevenueBreakdownTable } from "@/routes/custom-music/dsp-analytics/components/graphics/revenue-breakdown-table";
import { RevenueChart } from "@/routes/custom-music/dsp-analytics/components/graphics/revenue-chart";
import { useAnalyticsMonth } from "@/routes/custom-music/dsp-analytics/context/dsp-analytics-context";
import { getPreviousMonthRange } from "@/utils/date";
import { formatMonthString } from "@/utils/time";
import { Typography } from "@backpac/monica";
import { useState } from "react";

export const ArtistAnalytics = () => {
  const { selectedMonthRange } = useAnalyticsMonth();
  const workspaceId = useWorkspaceId();
  const {
    data: {
      data: { items: artistAnalytics },
    },
  } = useGetArtistAnalyticsApiV1Suspense(workspaceId, {
    from: formatMonthString(selectedMonthRange[0]),
    to: formatMonthString(selectedMonthRange[1]),
  });
  // previous revenue with the same length as the current revenue
  const {
    data: {
      data: { items: previousArtistAnalytics },
    },
  } = useGetArtistAnalyticsApiV1Suspense(workspaceId, {
    from: formatMonthString(getPreviousMonthRange(selectedMonthRange)[0]),
    to: formatMonthString(getPreviousMonthRange(selectedMonthRange)[1]),
  });

  const [selectedIds, setSelectedIds] = useState<string[]>(() => artistAnalytics.slice(0, 5).map((item) => item.name));

  return (
    <div className="flex flex-col gap-6">
      <RevenueChart analytics={artistAnalytics} previousAnalytics={previousArtistAnalytics} selectedIds={selectedIds} />
      <RevenueBreakdownTable
        title="Artist"
        analytics={artistAnalytics}
        selectedIds={selectedIds}
        setSelectedIds={setSelectedIds}
        additionalColumns={[
          {
            label: "Artist",
            render: (item) => (
              <Typography size="xs" color="textPrimary">
                {item.name}
              </Typography>
            ),
            position: "start",
          },
        ]}
      />
    </div>
  );
};
